import React from "react";

class DropdownGrpCli extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="01">Empresas</option>
        <option value="02">Particulares</option>
        <option value="03">Sócio ISQ</option>
        <option value="04">Empresa participada</option>
        <option value="05">Ad.Regional</option>
        <option value="06">Ad.Central</option>
        <option value="07">Ad.Local</option>
        <option value="08">Organismo Público</option>
      </React.Fragment>
    );
  }
}

export default DropdownGrpCli;
